export default {
  cellSpacing: 5,
  outerGutter: 40,
  gutterDesktop: 40,
  slidesToShow: {
    0: 1.5,
    758: 1.667,
    1000: 1.667,
    1240: 1.667,
  },
  gridWidths: {
    1000: 1000,
    1240: 1240,
  },
  imageHeights: {
    0: 240,
    758: 440,
    1000: 560,
  },
  slideHeights: {
    0: 240,
    758: 440,
    1000: 560,
  },
  currencies: {
    USD: '$',
  },
};
